export default ``



// WEBPACK FOOTER //
// ./src/blank.js